import { Outlet } from "@tanstack/react-router";
import { useT } from "@/glossary";
import { EXERCISES, type ExerciseId } from "@/lib/exercises";

export const ExerciseLayout = ({ id }: { id: ExerciseId }) => {
  const t = useT();
  return (
    <div className="flex flex-1 flex-col">
      <h1 className="mb-4 text-center font-bold text-xl">
        {EXERCISES[id].heading(t)}
      </h1>
      <Outlet />
    </div>
  );
};
